import * as React from 'react';
import formStyle from '../style/WForm.less';


interface WFormFieldMailProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: string;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    onValueChange(name: string, value: any): void;
}

export class WFormFieldMail extends React.Component<WFormFieldMailProps, {}> {

    constructor(props: any) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
    }
    onInputChange(event: any) {
        this.props.onValueChange(this.props.name, event.target.value);
    }

    render() {
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        return (
            <div className={formStyle.fieldBox}>
                    {this.props.label}
                    <div className={formStyle.input}>
                        <input
                            type='text'
                            className={formStyle.inputText}
                            name={this.props.name}
                            value={this.props.value ? this.props.value : ''}
                            readOnly = { disabled }
                            onChange={ this.onInputChange }
                            />
                    </div>
            </div>
        );
    }

}
